/* Enhance dynamically rendered photo fields without replacing app controls. */
(() => {
  let frame;

  function refresh() {
    frame = null;
    document.querySelectorAll('#teeFormInputs .tee-field--photo .tee-photo').forEach(photo => {
      const placeholder = photo.querySelector('.tee-photo-placeholder');
      const image = photo.querySelector('.tee-photo-image');
      const uploaded = !!photo.querySelector('.tee-photo-uploaded');
      const edit = photo.querySelector('.tee-btn--recustomize');
      if (placeholder && !placeholder.querySelector('.gp-upload-prompt')) {
        const prompt = document.createElement('span');
        prompt.className = 'gp-upload-prompt';
        prompt.textContent = 'Choose and upload your photo…';
        placeholder.append(prompt);
      }

      const label = photo.querySelector('.tee-btn--upload > span');
      if (placeholder && label?.textContent.trim() === 'Choose an image') {
        label.textContent = 'Select Image';
      }
      if (uploaded && label?.textContent.trim() === 'Choose another image') label.textContent = 'Re-Upload';
      if (edit?.textContent.trim() === 'Recustomize image') edit.textContent = 'Edit';
      const clear = photo.querySelector('.tee-photo-clear');
      if (clear && !clear.hasAttribute('aria-label')) clear.setAttribute('aria-label', 'Remove image');

      let status = photo.parentElement.querySelector('.gp-upload-status');
      if (!status) {
        status = document.createElement('p');
        status.className = 'gp-upload-status';
        status.setAttribute('role', 'status');
        status.textContent = 'Ready to Preview and Edit!';
        status.hidden = true;
        photo.after(status);
      }
      if (image && !image.dataset.gpLoadObserved) {
        image.dataset.gpLoadObserved = 'true';
        image.addEventListener('load', schedule);
        image.addEventListener('error', schedule);
      }
      status.hidden = !(uploaded && image?.complete && image.naturalWidth > 0 &&
        !photo.querySelector('.tee-photo-uploading'));

      if (!photo.parentElement.querySelector('.gp-upload-hint')) {
        const hint = document.createElement('ul');
        hint.className = 'gp-upload-hint';
        for (const text of ['Choose a clear, high-quality photo for the best result.',
          'Click Edit to adjust your image.', 'Click Re-Upload to choose a different photo.']) {
          const item = document.createElement('li');
          item.textContent = text;
          hint.append(item);
        }
        status.after(hint);
      }
      const hints = photo.parentElement.querySelector('.gp-upload-hint').children;
      if (hints[1]) hints[1].hidden = !uploaded || !edit;
      if (hints[2]) hints[2].hidden = !uploaded;
      photo.classList.add('gp-photo-upload');
    });
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(refresh);
  }

  // The app replaces fields when customers switch artwork backgrounds.
  new MutationObserver(records => {
    if (records.some(record => record.target.closest?.('#teeFormInputs') ||
      [...record.addedNodes].some(node => node.nodeType === 1 &&
        (node.matches('#teeFormInputs') || node.querySelector('#teeFormInputs'))))) schedule();
  }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['src'] });
  document.addEventListener('teeinblue-event-component-injected', schedule);
  document.addEventListener('teeinblue-event-campaign-loaded', schedule);
  refresh();
})();
